/** EMR application email format: allows internal .local demo domains. */

const APP_EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidAppEmail(value) {
  if (typeof value !== "string") return false;
  const email = value.trim();
  if (!email || /\s/.test(email)) return false;
  return APP_EMAIL_RE.test(email);
}
